import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { GrowthChartSelectable } from "./UIModels/GrowthChartsSelector";

interface GrowthChartsSidebarProps {
    charts: GrowthChartSelectable[];
    onChartSelectionChanged: (id: string, check: boolean) => void;
    onGrowthChartCategoryChanged: (check: boolean) => void;
    onVitalSignCategoryChanged: (check: boolean) => void;
    onAddVitalSignClicked: () => void;
}

class GrowthChartsSidebar extends BaseReactComponent<GrowthChartsSidebarProps> {
    public render(): JSX.Element {
        const growthCharts = this.props.charts.filter(p => !p.chart.isVitalSign);
        const vitalSignCharts = this.props.charts.filter(p => p.chart.isVitalSign);
        const areAllGrowthChartsSelected = growthCharts.every(chart => chart.isChecked);
        const areAllVitalSignChartsSelected = vitalSignCharts.every(chart => chart.isChecked);

        return (
            <div className="growth-charts-sidebar" id="growth-chart-sidebar">
                <div className="growth-charts-sidebar-item add-vital-sign" id="growth-charts-sidebar-item-add-vital-sign" data-cy="growthCharts-addVitalSign">
                    <a onClick={() => this.props.onAddVitalSignClicked?.()}>&nbsp;</a>
                    <a onClick={() => this.props.onAddVitalSignClicked?.()}>
                        {cacheStore.GetString("AddVitalSignsLabel")}
                    </a>
                </div>
                {growthCharts?.length > 0 && (
                    <div>
                        {this.renderGrowthChartsCategoryDiv(areAllGrowthChartsSelected)}
                        {growthCharts.map(chart => this.renderGrowthChartDivs(chart))}
                    </div>
                )}
                {vitalSignCharts?.length > 0 && (
                    <div>
                        {this.renderVitalSignsCategoryDiv(areAllVitalSignChartsSelected)}
                        {vitalSignCharts.map(chart => this.renderVitalSignDivs(chart))}
                    </div>
                )}
            </div>
        );
    }

    private renderGrowthChartsCategoryDiv(areAllGrowthChartsSelected: boolean): JSX.Element {
        const growthChartsCategoryId = "growth-chart-sidebar-category";

        return (
            <div className="growth-charts-sidebar-item growth-charts-sidebar-item-category" key="growth-chart-category">
                <CheckboxControl
                    id={growthChartsCategoryId}
                    dataCy="growthCharts-category"
                    checked={areAllGrowthChartsSelected}
                    onChange={() => this.props.onGrowthChartCategoryChanged?.(!areAllGrowthChartsSelected)}
                />
                <label htmlFor={growthChartsCategoryId}>
                    {cacheStore.GetString("GrowthChartsLabel")}
                </label>
            </div>
        );
    }

    private renderVitalSignsCategoryDiv(areAllVitalSignChartsSelected: boolean): JSX.Element {
        const vitalSignsCategoryId = "vital-sign-sidebar-category";

        return (
            <div className="growth-charts-sidebar-item growth-charts-sidebar-item-category" key="vital-signs-category">
                <CheckboxControl
                    id={vitalSignsCategoryId}
                    dataCy="vitalSigns-category"
                    checked={areAllVitalSignChartsSelected}
                    onChange={() => this.props.onVitalSignCategoryChanged?.(!areAllVitalSignChartsSelected)}
                />
                <label htmlFor={vitalSignsCategoryId}>
                    {cacheStore.GetString("VitalSignsLabel")}
                </label>
            </div>
        );
    }

    private renderGrowthChartDivs(selectableChart: GrowthChartSelectable): JSX.Element {
        const chartId = `growth-charts-category-chart-${selectableChart.chart.id}`;

        return (
            <div className="growth-charts-sidebar-item growth-charts-sidebar-item-chart" key={`growth-chart-${chartId}`}>
                <CheckboxControl
                    id={chartId}
                    dataCy={`growthCharts-category-${selectableChart.chart.id}`}
                    checked={selectableChart.isChecked}
                    onChange={() => this.props.onChartSelectionChanged?.(selectableChart.chart.id, !selectableChart.isChecked)}
                />
                <label htmlFor={chartId}>{selectableChart.chart.name}</label>
            </div>
        );
    }

    private renderVitalSignDivs(selectableChart: GrowthChartSelectable): JSX.Element {
        const chartId = `growth-charts-category-chart-${selectableChart.chart.id}`;

        return (
            <div className="growth-charts-sidebar-item growth-charts-sidebar-item-chart" key={`vital-signs-${chartId}`}>
                <CheckboxControl
                    id={chartId}
                    dataCy={`growthCharts-category-${selectableChart.chart.id}`}
                    checked={selectableChart.isChecked}
                    onChange={() => this.props.onChartSelectionChanged(selectableChart.chart.id, !selectableChart.isChecked)}
                />
                <label htmlFor={chartId}>{selectableChart.chart.name}</label>
            </div>
        );
    }
}

export { GrowthChartsSidebar };
